import PropTypes from 'prop-types'
import { createContext, useContext } from 'react'

import { anim, prog } from '../motion'

/**
 * Text der Version 8: statt langer Captions unten links eine kurze, große
 * Headline oben links, die sich Wort für Wort aufbaut, dazu eine knappe
 * Zeile. Sie steht nur zu Beginn einer Station und geht wieder, bevor die
 * Szene ihre Panels zeigt. `show` und `hide` sind Bereiche von --l.
 */

const range = PropTypes.arrayOf(PropTypes.number)

// Extras der Version 7 fragen hierüber, ob sie Captions oder Headlines zeigen
const TextModeContext = createContext('caption')
export const TextModeProvider = TextModeContext.Provider
export const useTextMode = () => useContext(TextModeContext)

export function Headline({ show, hide, title, line, place = 'top' }) {
  const words = title.split(' ')
  const [a, b] = show
  const step = (b - a) / (words.length + 1)
  return (
    <div
      className={place === 'bottom' ? 'hl hl--bottom' : 'hl'}
      style={anim({ at: [a, a + step], out: hide, y: 12, oy: -12 })}
    >
      <div className='hl__title'>
        {words.map((w, i) => (
          <span
            key={i}
            className='hl__word'
            style={{
              ...prog([a + step * i, a + step * (i + 2)]),
              opacity: 'calc(0.12 + 0.88 * var(--p))',
              transform:
                'translateY(calc((1 - var(--p)) * 10px * var(--motion)))'
            }}
          >
            {w}{' '}
          </span>
        ))}
      </div>
      {line && (
        <p
          className='hl__line'
          style={anim({ at: [b - step, b + step], y: 8 })}
        >
          {line}
        </p>
      )}
    </div>
  )
}

Headline.propTypes = {
  show: range.isRequired,
  hide: range,
  title: PropTypes.string.isRequired,
  line: PropTypes.string,
  place: PropTypes.oneOf(['top', 'bottom'])
}
